module.exports = __webpack_public_path__ + "img/1560945260.5826d1f0.jpg";